import { createSlice } from "@reduxjs/toolkit";

const requiredFields = {
  name: "",
  order_type: "",
  client_id: "",
  brand_ids: "",
  country_id: "",
  city_id: "",
  currency: "",
  timezone: "",
  open_t: "",
  close_t: "",
  contact_email: "",
  location: "",
};

export const detailsFormValidationSlice = createSlice({
  name: "detailsFormErrorValidations",
  initialState: { value: requiredFields },
  reducers: {
    detailsFormErrorValidations: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { detailsFormErrorValidations } =
  detailsFormValidationSlice.actions;

export default detailsFormValidationSlice.reducer;
